import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const initialState = {
  securities: [],
  securitiesLoaded: false,
  loading: false,
  error: null,
};

const securitiesSlice = createSlice({
  name: "securities",
  initialState,
  reducers: {
    setSecurities: (state, action) => {
      state.securities = action.payload;
      state.securitiesLoaded = true;
      state.loading = false;
      state.error = null;
    },
    updateSecurities: (state, action) => {
      if (
        action.payload?.status === "success" &&
        action.payload?.securityMasterItems &&
        action.payload?.securityMasterItems?.length > 0
      ) {
        const updatedSecurities = action.payload?.securityMasterItems;

        updatedSecurities?.forEach((payloadItem) => {
          const existingSecurity = state.securities.find(
            (security) => security.tickerId === payloadItem.tickerId
          );
          if (existingSecurity) {
            state.securities = state.securities.map((security) =>
              security.tickerId === payloadItem.tickerId
                ? { ...security, ...payloadItem }
                : security
            );
          } else {
            state.securities.push(payloadItem);
          }
        });

        toast.success("Securities are Updated");
      } else {
        toast.error("Securities cannot be Updated");
      }
      state.loading = false;
      state.error = null;
    },
    updateFigi: (state, action) => {
      if (
        action.payload?.status === "success" &&
        action.payload?.securityMasterItems &&
        action.payload?.securityMasterItems?.length > 0
      ) {
        const updatedSecurities = action.payload?.securityMasterItems;
        updatedSecurities?.forEach((payloadItem) => {
          const securityIndex = state.securities.findIndex(
            (security) => security.tickerId === payloadItem.tickerId
          );

          if (securityIndex !== -1) {
            state.securities[securityIndex] = {
              ...state.securities[securityIndex],
              ...payloadItem,
            };
          }
        });

        toast.success(
          action.payload?.updatedTickerCount +
            " out of " +
            action.payload?.requestedTickerCount +
            " Tickers Updated"
        );
      }
      state.loading = false;
      state.error = null;
    },
    setSecuritiesLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSecuritiesError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  setSecurities,
  updateSecurities,
  updateFigi,
  setSecuritiesLoading,
  setSecuritiesError,
} = securitiesSlice.actions;

// Selectors
export const selectSecurities = (state) => state.securities.securities;
export const selectSecuritiesLoaded = (state) => state.securities.securitiesLoaded;
export const selectSecuritiesLoading = (state) => state.securities.loading;
export const selectSecuritiesError = (state) => state.securities.error;

export default securitiesSlice.reducer;
